import type { ReactNode } from 'react';
import { cx } from './util.ts';
import './Icon.css';

/*
 * Set propio de iconos (docs/design.md §7): rejilla de 24, trazo redondeado de 1,75 (2,25 en
 * proyector), sin rellenos. Círculo = agente, cuadrado = persona, chevrón = avance.
 * Los canales son genéricos: «whatsapp» es un bocadillo, nunca el logotipo de la marca.
 */
const PATHS = {
  email: (
    <>
      <rect x="3" y="5.5" width="18" height="13" rx="2" />
      <path d="m3.75 7.25 8.25 6 8.25-6" />
    </>
  ),
  portal: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 8.5h18" />
      <path d="M6 6.25h.01M8.5 6.25h.01" />
      <path d="m10.5 12 3 2.75-3 2.75" />
    </>
  ),
  whatsapp: (
    <>
      <path d="M12 4a8 8 0 0 1 0 16 8.1 8.1 0 0 1-3.7-.9L4 20l1-4.1A8 8 0 0 1 12 4Z" />
      <path d="M8.5 12h.01M12 12h.01M15.5 12h.01" />
    </>
  ),
  documento: (
    <>
      <path d="M6 3h8.5L18 6.5V21H6z" />
      <path d="M14 3v4h4" />
      <path d="M9 12h6M9 15.5h6M9 9h2" />
    </>
  ),
  check: <path d="m5 12.5 4.5 4.5L19 7.5" />,
  alerta: (
    <>
      <path d="M10.3 4.5a2 2 0 0 1 3.4 0l7.3 12.6a2 2 0 0 1-1.7 3H4.7a2 2 0 0 1-1.7-3z" />
      <path d="M12 9.5v4" />
      <path d="M12 16.75h.01" />
    </>
  ),
  escudo: (
    <>
      <path d="M12 3 19 6v5.5c0 4.4-3 7.8-7 9.5-4-1.7-7-5.1-7-9.5V6z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  persona: (
    <>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 20c.8-3.6 3.6-5.5 7-5.5s6.2 1.9 7 5.5" />
    </>
  ),
  reloj: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  descarga: (
    <>
      <path d="M12 4v11" />
      <path d="m7.5 10.5 4.5 4.5 4.5-4.5" />
      <path d="M5 19.5h14" />
    </>
  ),
  filtro: <path d="M4 5h16l-6 7.5V19l-4-2v-4.5z" />,
  buscar: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4 4" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 11v5" />
      <path d="M12 8h.01" />
    </>
  ),
  cerrar: <path d="M6.5 6.5l11 11M17.5 6.5l-11 11" />,
  avance: <path d="m9 6 6 6-6 6" />,
  desplegar: <path d="m6 9 6 6 6-6" />,
  flecha: (
    <>
      <path d="M4 12h15" />
      <path d="m14 7 5 5-5 5" />
    </>
  ),
  revisar: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="1" />
      <path d="M7 12s1.9-3.5 5-3.5 5 3.5 5 3.5-1.9 3.5-5 3.5S7 12 7 12z" />
      <path d="M12 12h.01" />
    </>
  ),
  aprobar: (
    <>
      <rect x="3.5" y="3.5" width="17" height="17" rx="1" />
      <path d="m8 12.25 2.75 2.75L16 9.5" />
    </>
  ),
  escalar: (
    <>
      <circle cx="7" cy="17" r="3" />
      <path d="M9.25 14.75 13.5 10.5" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1" />
    </>
  ),
  agente: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m10.5 8.5 3.5 3.5-3.5 3.5" />
    </>
  ),
  euro: (
    <>
      <path d="M17 6.5a6.5 6.5 0 1 0 0 11" />
      <path d="M5 10.5h8M5 13.5h8" />
    </>
  ),
  sol: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
    </>
  ),
  luna: <path d="M19 14.5A7.5 7.5 0 0 1 9.5 5a7.5 7.5 0 1 0 9.5 9.5Z" />,
  proyector: (
    <>
      <rect x="3" y="4" width="18" height="12" rx="1.5" />
      <path d="M12 16v4M8.5 20h7" />
    </>
  ),
  'estado-ok': (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8.25 12.25 2.5 2.5 5-5" />
    </>
  ),
  'estado-escalado': (
    <>
      <rect x="4" y="4" width="16" height="16" rx="1" />
      <path d="M12 16V8.5M8.75 11.5 12 8.25l3.25 3.25" />
    </>
  ),
  'estado-error': (
    <>
      <path d="M8.3 3.5h7.4l4.8 4.8v7.4l-4.8 4.8H8.3l-4.8-4.8V8.3z" />
      <path d="m9.5 9.5 5 5m0-5-5 5" />
    </>
  ),
  'estado-pendiente': <circle cx="12" cy="12" r="8.5" />,
  'estado-auto': (
    <>
      <path d="M2 12h3.5M18.5 12H22" />
      <circle cx="12" cy="12" r="6.5" />
      <path d="m9.25 12.1 1.9 1.9 3.6-3.6" />
    </>
  ),
  'estado-sospechoso': (
    <>
      <path d="M10.3 4.5a2 2 0 0 1 3.4 0l7.3 12.6a2 2 0 0 1-1.7 3H4.7a2 2 0 0 1-1.7-3z" />
      <path d="M12 9.5v4" />
      <path d="M12 16.75h.01" />
    </>
  ),
} satisfies Record<string, ReactNode>;

export type IconName = keyof typeof PATHS;

export const ICON_NAMES = Object.keys(PATHS) as IconName[];

export interface IconProps {
  name: IconName;
  /** Si el icono va solo y transmite algo, su etiqueta. Sin etiqueta es decorativo. */
  label?: string;
  /** Tamaño CSS (por defecto 1.25em, sigue al texto). */
  size?: string | number;
  className?: string;
}

export function Icon({ name, label, size = '1.25em', className }: IconProps) {
  const a11y = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true as const };
  return (
    <svg
      className={cx('af-icon', className)}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      {...a11y}
    >
      {PATHS[name]}
    </svg>
  );
}
